import React, { Component } from 'react'
import { FormBox, CustomBox, FAIcon, FormBoxContext, Button, Row, Col } from 'common-controls/Core'
import { InputGroupAddon, InputGroup, InputGroupText, Input, FormFeedback, Container } from 'reactstrap'
import styles from './Login.less'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import * as queryString from 'query-string'
import _ from 'common-tools/LodashHelper'

class LoginFormButtons extends React.Component {
  static contextType = FormBoxContext

  render () {
    const { submitClick } = this.props
    const { loading } = this.context

    return (
      <div className={styles.formActions}>
        <div className={styles.formAction}>
          <Button size='lg' color='primary' type='submit' loading={loading} onClick={submitClick}>Sign In</Button>
        </div>
        <div className={styles.formAction}>
          <Button color='link' disabled={loading}>Forgot your password?</Button>
        </div>
      </div>
    )
  }
}

class LoginPlain extends Component {
  constructor (props) {
    super(props)

    this.state = {
      logo: ''
    }
  }
  onSubmit = (values) => {
    const { sendToURL, setAccount, formCheckForSubmissionErrors, AccountLogin, location } = this.props
    return AccountLogin(values)
      .then(({ data, extra }) => {
        setAccount(extra.token, data)
        let queryVars = queryString.parse(location.search)
        sendToURL(queryVars.returnURL || '/App')
      }).catch(formCheckForSubmissionErrors)
  }
  componentDidMount = () => {
    const { GetSetting } = this.props

    GetSetting({
      Names: ['CompanyLoginLogo'] })
      .then(({ data, extra }) => {
        this.setState({ logo: _.first(data)?.Value || '' })
      })
  }

  render () {
    const { data } = this.props
    const { logo } = this.state

    return (
      <div className={styles.loginRoot}>
        {/* Decorative dot-grid accent */}
        <div className={styles.accentDot} />

        {/* Glassmorphism card */}
        <div className={styles.card}>
          {/* Logo */}
          <div className={styles.logo}>
            <img src={logo || '/Content/images/logofull.png'} alt='Company Logo' />
          </div>

          {/* Headline */}
          <div className={styles.headline}>
            <h2>Welcome back</h2>
            <p>Sign in to your workspace to continue</p>
          </div>

          {/* Form */}
          <FormBox form='Login' className={styles.form} loading={data.loadingAccountLogin} onSubmit={this.onSubmit} showButtons>
            <Container className={styles.formField}>
              <Row>
                <CustomBox name='EmailAddress' noLayout>
                  {({ value, onChange, showError, errorMessage, loading }) =>
                    <Col sm={12}>
                      <InputGroup className='mb-3'>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <FAIcon name='user' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" onChange={onChange} disabled={loading} value={value} invalid={showError} placeholder="Login Id" autoComplete="username" />
                        <FormFeedback>{errorMessage}</FormFeedback>
                      </InputGroup>
                    </Col>
                  }
                </CustomBox>
              </Row>
              <Row>
                <CustomBox name='Password' noLayout>
                  {({ value, onChange, showError, errorMessage, loading }) =>
                    <Col sm={12}>
                      <InputGroup className='mb-3'>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <FAIcon name='lock' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="password" onChange={onChange} disabled={loading} width='100%' value={value} invalid={showError} placeholder="Password" autoComplete="password" />
                        <FormFeedback>{errorMessage}</FormFeedback>
                      </InputGroup>
                    </Col>
                  }
                </CustomBox>
              </Row>
            </Container>
            <LoginFormButtons />
          </FormBox>

          {/* Footer */}
          <div className={styles.cardFooter}>NUIMS Office Management System</div>
        </div>
      </div>
    )
  }
}

export const Login = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount
  ], [
    ah.sendToURL,
    ah.setAppState,
    ah.formCheckForSubmissionErrors,
    ah.setAccount
  ]),
  QueryWrapper({
    key: 'Login',
    actions: [
      {
        url: '/Security/Login',
        prop: 'AccountLogin',
        map: false
      },
      {
        url: '/Settings/Get',
        prop: 'GetSetting',
        map: 'settings'
      }
    ]
  })
)(LoginPlain)

export default Login
